import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { resolveContent } from '@nu-art/ts-common';
import { ICONS } from '../../../icons/index.js';
import './GenericWarningDialog.scss';
export class GenericWarningDialog extends ComponentSync {
    static show = (props) => {
        const { closeOnClickAway, ...rest } = props;
        ModuleFE_Dialog.show({ content: _jsx(GenericWarningDialog, { ...rest }), closeOverlayOnClick: () => !!closeOnClickAway });
    };
    static defaultProps = {
        headerTitle: 'Warning',
        confirmationButtonLabel: 'Confirm',
    };
    // ######################### Logic #########################
    closeDialog = () => {
        ModuleFE_Dialog.close();
    };
    executeAction = async () => {
        await this.props.confirmationAction();
        this.closeDialog();
    };
    // ######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'generic-warning-dialog', id: this.props.id, children: [this.renderHeader(), this.renderBody(), this.renderFooter()] });
    }
    renderHeader = () => {
        return _jsxs(LL_H_C, { className: 'generic-warning-dialog__header', children: [_jsx("div", { className: 'generic-warning-dialog__header__title', children: this.props.headerTitle }), _jsx(ICONS.x.component, { onClick: this.closeDialog })] });
    };
    renderBody = () => {
        const content = resolveContent(this.props.bodyContent);
        return _jsx("div", { className: 'generic-warning-dialog__body', children: content });
    };
    renderFooter = () => {
        return _jsxs(LL_H_C, { className: 'generic-warning-dialog__footer', children: [_jsx(Button, { variant: 'secondary', onClick: this.closeDialog, children: "Cancel" }), _jsx(Button, { variant: 'primary', onClick: this.executeAction, children: this.props.confirmationButtonLabel })] });
    };
}
//# sourceMappingURL=GenericWarningDialog.js.map